/** A single accessible announcement group with visual copies for seamless motion. */
class MabeAnnouncementMarquee extends HTMLElement {
  #observer;
  #width = 0;
  #paused = false;

  connectedCallback() {
    this.querySelector('button')?.addEventListener('click', this.#toggle);
    this.#observer = new ResizeObserver(([entry]) => {
      const width = Math.round(entry.contentRect.width);
      if (width === this.#width) return;
      this.#width = width;
      this.#build();
    });
    this.#observer.observe(this.querySelector('.mabe-announcement-marquee__viewport'));
    document.fonts.ready.then(() => { if (this.isConnected) this.#build(); });
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.querySelector('button')?.removeEventListener('click', this.#toggle);
  }

  #copy(element) {
    const copy = element.cloneNode(true);
    copy.setAttribute('data-marquee-copy', '');
    copy.setAttribute('aria-hidden', 'true');
    copy.removeAttribute('data-original-half');
    copy.removeAttribute('data-original-items');
    for (const node of copy.querySelectorAll('[id], [ref], [data-shopify-editor-block]')) {
      node.removeAttribute('id');
      node.removeAttribute('ref');
      node.removeAttribute('data-shopify-editor-block');
    }
    for (const link of copy.querySelectorAll('a')) link.tabIndex = -1;
    return copy;
  }

  #build() {
    this.querySelectorAll('[data-marquee-copy]').forEach(copy => copy.remove());
    const items = this.querySelector('[data-original-items]');
    const half = this.querySelector('[data-original-half]');
    const track = this.querySelector('.mabe-announcement-marquee__track');
    const width = items?.getBoundingClientRect().width;
    if (!width || !half || !track) return;
    const gap = parseFloat(getComputedStyle(this).getPropertyValue('--mabe-announcement-gap')) || 48;
    const copies = Math.max(1, Math.ceil(this.#width / (width + gap)) + 1);
    for (let index = 1; index < copies; index++) half.append(this.#copy(items));
    const period = half.getBoundingClientRect().width + gap;
    track.append(this.#copy(half));
    const speed = Math.max(15, Math.min(80, Number(this.dataset.speed) || 35));
    this.style.setProperty('--mabe-announcement-duration', `${period / speed}s`);
    this.setAttribute('data-ready', '');
  }

  #toggle = () => {
    this.#paused = !this.#paused;
    this.toggleAttribute('data-paused', this.#paused);
    const button = this.querySelector('button');
    button?.setAttribute('aria-pressed', String(this.#paused));
    button.querySelector('[aria-hidden]').textContent = this.#paused ? '▶' : 'Ⅱ';
    button.querySelector('.visually-hidden').textContent = this.#paused ? 'Lauftext fortsetzen' : 'Lauftext pausieren';
  };
}

if (!customElements.get('mabe-announcement-marquee')) {
  customElements.define('mabe-announcement-marquee', MabeAnnouncementMarquee);
}
